 
 <div style="height:92vh">

<app-modal-header [headerTitle]="headerTitle" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>

<div *ngIf="listsLoaded == true && item != null">

  <div mat-dialog-content>

  <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
      {{currentLanguage.Name}}
  </div>

  <div *ngIf="CurrentLocalizedData() != null" class="languageContainer">

      <div class="form-group row">
          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Name" [(ngModel)]="CurrentLocalizedData().Name">
                  <label for="">Name</label>
              </div>
          </div>

          <div class="col-6">
            <div class="form-material">
                <input matInput Xplaceholder="Spoken Name" [(ngModel)]="CurrentLocalizedData().AlternateName">
                <label for="">Subname</label>
            </div>
        </div>

        <div class="col-6">
            <div class="form-material">
                <input matInput [(ngModel)]="CurrentLocalizedData().AbbreviatedName">
                <label for="">Abbreviated Name</label>
            </div>
        </div>
      </div>
 
  </div>


  <mat-tab-group style="width:70vw">

        <mat-tab label="Service Details">
          <ng-template matTabContent>
           
  <!-- <div  style="border-bottom:1px solid gray">All Languages</div> -->
  <div class="globalContainer">

    <div class="row">

        <div class="col-sm-6">
            
  <div class="row">
      
        <div class="col-6">
            <div class="form-material">

              <select [ngModel]="item.ReligionBranch?.Id"  (ngModelChange)="item.ReligionBranch = setModelValue($event, item.ReligionBranch)">
                <option></option>
                <option *ngFor="let section of religionBranches" [ngValue]="section.Id">
                    {{section.Name}}
                </option>
              </select>

              <label for="">Religion Branch</label>
            </div>
        </div>
 
        <div class="col-6">
                <div class="form-material">
                <input type="number" matInput Xplaceholder="Display Order" [(ngModel)]="item.DisplayOrder">
                <label for="">Display Order</label>
                </div>
                </div>
 

<div class="col-6">
    <div class="form-material">
        <select [ngModel]="item.FeastType?.Id"  (ngModelChange)="item.FeastType = setModelValue($event, item.FeastType)">
            <option></option>
            <option *ngFor="let section of feastTypes" [ngValue]="section.Id">
                {{section.Localized[0].Name}}
            </option>
        </select>
        <label for="">Feast Type</label>
    </div>
</div>

<div class="col-6">
    <div class="form-material">
      <select [ngModel]="item.Season?.Id"  (ngModelChange)="item.Season = setModelValue($event, item.Season)">
          <option></option>
      <option *ngFor="let section of seasons" [ngValue]="section?.Id">
            {{section.Localized[0]?.Name}}
      </option>
    </select>
        <label for="">Season</label>
    </div>
</div>

<div class="col-6">
    <div class="form-material">
      <select [ngModel]="item.LectionarySource?.Id"  (ngModelChange)="item.LectionarySource = setModelValue($event, item.LectionarySource)">
        <option *ngFor="let section of lectionarySources" [ngValue]="section?.Id">
            {{section.NameAbbreviated}}
        </option>
    </select>
        <label for="">Lectionary Source</label>
    </div>
</div>
  
<div class="col-6">
    <div class="form-material">
        <input type="number" matInput [(ngModel)]="item.ProperNumber"> 
        <label for="">Proper Number</label>
    </div>
</div>


<div class="col-6">
        <div class="form-material"> 
            <select multiple [(ngModel)]="item.VestmentColors" [compareWith]="compareColor" style="height: 150px;"> 
                <option *ngFor="let section of vestmentColors" [ngValue]="section"  >
                    {{section.Localized[0].Name}}
                </option>
            </select>

            <label for="">Vestment Colors</label>
        </div>
    </div>

        <div class="col-6">
            <div class="" style="margin-top:20px;">
                <div class="cbRow">
                    <div class=""><input type="checkbox" [(ngModel)]="item.IsActive"></div>
                    <div class=""><label for="">Is Active</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox" [(ngModel)]="item.UseProperMap"></div>
                    <div class=""><label for="">Use Proper Map</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.Exclusive"></div>
                    <div class=""><label for="">Exclusive</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.ExclusiveForFeastType"></div>
                    <div class=""><label for="">Exclusive For Feast Type</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.IsTrialUse"></div>
                    <div class=""><label for="">Is Trial Use</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.Hidden"></div>
                    <div class=""><label for="">Hidden</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.IsHiddenForMappingsOfSpecialService"></div>
                    <div class=""><label for="">Is Hidden for Mappings of Special Service</label></div> 
                </div>
                <div class="cbRow">
                    <div class=""><input type="checkbox"  [(ngModel)]="item.IgnoreSpecialServiceMappings"></div>
                    <div class=""><label for="">Ignore Mappings From Special Services</label></div> 
                </div>
            </div> 

        </div>
  


</div>
 

  </div>

        <div class="col-sm-6 ">
 

    
        <div class="container">
            
         <div class="row">
             
            <div class="col-12">
                <div class="form-material">
                    <select [ngModel]="item.ServiceDateType?.Id"  (ngModelChange)="item.ServiceDateType = setModelValue($event, item.ServiceDateType)"> 
                        <option></option>
                        <option *ngFor="let section of serviceDateTypes" [ngValue]="section.Id">
                            {{section.Localized[0].Name}}
                        </option>
                    </select>
    
                    <label for="">Service Date Type</label>
                </div>
            </div>
        </div>
    
        <div class="row">
            
            <div class="col-12" *ngIf="item.ServiceDateType?.Id == '7aeeae22-3971-4ac9-bd4a-7258ea5189be'">
                <div class="form-material">
                    <select [(ngModel)]="item.DesignatedApiService">
                        <option></option>
                        <option value=1>The First Sunday of Advent</option>
                        <option value=2>Easter</option>
                        <option value=3>Ash Wednesday</option>
                        <option value=8>The Last Sunday After Pentecost</option>

                        <option value=9>Holy Cross Day</option> 
                        <option value=10>Pentecost/Whitsunday</option> 
                        <option value=11>Thanksgiving Day</option> 
                        <option value=12>All Saints Day</option> 
                        <option value=13>Labor Day</option> 
                

                        <optgroup label="Ember Days">
                            <option value=31>Ember Wednesday After Holy Cross</option>
                            <option value=32>Ember Wednesday After Pentecost</option>
                            <option value=33>Ember Wednesday In December</option>
                        </optgroup> 

                        <optgroup label="Days After Christmas">
                            <option value=40>Thursday After Christmas Day</option>
                            <option value=41>Friday After Christmas Day</option> 
                            <option value=42>Saturday After Christmas Day</option> 
                            <option value=7>The First Sunday After Christmas Day</option>
                        </optgroup> 

                        <optgroup label="The Epiphany">
                            <option value=4>The Epiphany</option>
                            <option value=43>Monday After The Epiphany</option> 
                            <option value=48>Tuesday After The Epiphany</option>    
                            <option value=44>Wednesday After The Epiphany</option> 
                            <option value=45>Thursday After The Epiphany</option>   
                            <option value=46>Friday After The Epiphany</option>  
                            <option value=47>Saturday After The Epiphany</option> 
                            <option value=5>The First Sunday After The Epiphany</option>
                        </optgroup> 

                    </select>

                    <label for="">API Designated Service</label>
                </div>
            </div>

        </div>

 

        <div class="row">
            <div class="col-12" *ngIf="item.ServiceDateType?.Id=='9a6dd1ab-6d8e-46c9-83df-52370a3e116b'">
                <div class="form-material"> 
                    <input type="number" matInput Xplaceholder="Fixed Date Month" [(ngModel)]="item.FixedDateMonth">
                    <label for="">Fixed Date Month</label>
                </div>
            </div>
    
            <div class="col-12" *ngIf="item.ServiceDateType?.Id=='9a6dd1ab-6d8e-46c9-83df-52370a3e116b'">
                <div class="form-material">
                    <input type="number" matInput Xplaceholder="Fixed Date Day" [(ngModel)]="item.FixedDateDay">
                    <label for="">Fixed Date Day</label>
                </div>
            </div>
        </div>
    
        <div class="row">
            <div class="col-12" *ngIf="item.ServiceDateType?.Id=='e822f8c6-351b-45c2-8459-f60c319728cc'">
                    <div class="form-material">
                        <input type="number" matInput Xplaceholder="Days From Other Service" [(ngModel)]="item.OtherServiceDayOffset">
                        <label for="">Days From Other Service</label>
                    </div>
                </div>
    
            <div class="col-12" *ngIf="item.ServiceDateType?.Id=='e822f8c6-351b-45c2-8459-f60c319728cc'">
                <div class="form-material"> 
                    <label for="">Other Service Id</label>
                    <div><input type="text" matInput [(ngModel)]="item.OtherServiceId"></div>
                    <!-- -- {{item.OtherServiceId}} -- -->
                    <!-- <app-service-edit-related-service-lookup [defaultServiceName]="parentServiceName" (serviceSelected)="serviceSuggestSelected($event)"></app-service-edit-related-service-lookup> -->
                </div>
            </div>
    
        </div>
    
    
        </div>
    
    
    <div class="col-12">
        <div class="form-material"> 
            <div>{{item.Id}}</div>
            <label for="">Service Id</label>
        </div>

        <div class=""> 
            <div class="form-material">
                <input type="text" matInput [(ngModel)]="item.ProofedByName" readonly/>
                <label for="">Proofed</label>
            </div>
        </div>
              
    </div>

        </div>


        </div>
    </div>

        <div mat-dialog-actions class="float-right">

            <div style="margin-bottom:30px"> 
                <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>  
                <button mat-button (click)="save(false)" class="btn btn-sm btn-outline-primary" style="margin-right:10px">{{saveButtonText}}</button>
                <button mat-button (click)="save(true)" class="btn btn-sm btn-outline-primary">Save and Proof</button>
            </div>
 
        </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Mappings" *ngIf="item.Id != null">
          <ng-template matTabContent>
            
            <div *ngIf="item.UseProperMap==true" class="properMappingsWarning">This Service uses Mappings from the Proper Number assigned for it. Use Admin - Propers to update the mappings.</div>
            
            <div class="mappings">
                <app-mappings [serviceId]="item.Id" [isServiceUsingProperMap]="item.UseProperMap"></app-mappings>
            </div>

          </ng-template>
        </mat-tab> 

        <mat-tab label="Propers" *ngIf="item.Id != null">
            <ng-template matTabContent>
              
              <div class="propers">
                  <app-service-edit-view-available-propers [serviceId]="item.Id"></app-service-edit-view-available-propers>
              </div>
  
            </ng-template>
          </mat-tab> 

      </mat-tab-group> 

</div>

<div *ngIf="listsLoaded == false || item == null">
  One moment please
</div>

        
</div>